export function canAccessPage(user, page) {
  const accessiblePages = user?.accessible_pages;
  if (!Array.isArray(accessiblePages)) return false;
  return accessiblePages.includes(page);
}
